export const REIMBURSEMENT_API_ENDPOINTS = {
  VERIFY_BANK_ACCOUNT: '/claimDetails/bank-account/verify',
};
